import { Injectable } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class OrderHistoryService {

    public _orderHistorySubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    public orderHistorySubject = this._orderHistorySubject.asObservable();

    /** Compteur incrémenté à chaque fois que l'historique doit être rechargé */
    readonly refreshTick = toSignal(this.orderHistorySubject, { requireSync: true });
}
